/**
 * @author vishwadeep.kapooe
 * RestaurantDeals actions
 *
 */
// import axios from 'axios';
import remove from 'lodash/remove';

import endpoint from '../../config/endPoints';
import { rootApiResponse } from '../HeaderContainer/actions';
import * as reqHandler from '../../config/services/serviceHandler';
import { utils } from '../../devUtils';
import { DEFAULT_WEB_CONSTANT } from '../HomePage/constants';
import {
  DEFAULT_ACTION,
  FETCH_GDD_DATA_SUCCESS,
  CHANGE_SEARCH_FORM,
  // FETCH_GDD_DATA,
  // FETCH_GDD_DATA_ERROR,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

const fetchGddDataSuccess = (payload) => ({ type: FETCH_GDD_DATA_SUCCESS, payload });
/**
 * @function fetchGddData
 * @param {object {city}} payload
 */
export const fetchGddData = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(defaultAction());

    const _payload = { ...payload, ...DEFAULT_WEB_CONSTANT };
    const res = await reqHandler.getHandler(api, endpoint.GET_GDD_PAGE, _payload);
    const value = await reqHandler.getHandler(api, endpoint.GET_MERCHANT_CATEGORIES, DEFAULT_WEB_CONSTANT);
    const response = updateResponse(res.result, value);
    dispatch(fetchGddDataSuccess(response));
  } catch (err) {
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};

export const changeSearchBox = (value) => ({ type: CHANGE_SEARCH_FORM, payload: value });

/**
 * @description remove used to hadle the @constant coming from API
 * @param {mainAPI} originalValue
 * @param {*mergedata} putValue
 */
const updateResponse = (originalValue, putValue) => {
  remove(putValue.categories, { display_category: null });
  const data = {
    div_type: 'gddCategories',
    title: 'Restaurant Categories',
    data: putValue.categories,
  };
  originalValue.push(data);
  return originalValue;
};



// WEBPACK FOOTER //
// client/containers/RestaurantDeals/actions.js